import React, { useState } from 'react';
import CardFormInvoice from '@ui-components/card/form-invoice';
import { validateFormCard } from '@containers/validators';
import { createCreditCardTransaction } from '@services/credit-card';
import { MIN_AMOUNT_CARD } from '@constants';
import language from '@language';

const initialStateFields = {
    client_number: '',
    property_name: '',
    document: '',
    email: '',
    invoices: [{
        id: 0,
        invoice_number: '',
        amount: ''
    }],
    total: 0
};

const CardFormInvoiceContainer = (props) => {

    const [fields, setFields] = useState(initialStateFields);
    const [errors, setErrors] = useState<any>('');

    const handleSubmit = () => {
        const errorValidations = validateFormCard(fields, window.country);
        setErrors(errorValidations);

        if (Object.keys(errorValidations).length > 0)
            return;

        if (!isSuccessAmount()) 
            return;

        saveForm();
    }

    const saveForm = async () => {
        try {
            const saved = await createCreditCardTransaction({ fields, country: props.country });
            props.onSubmit({"transaction": saved, "totalAmount": fields.total});
        } catch(e) {
            setErrors({general: language.card.errorSaveForm });
        }
    }

    const isSuccessAmount = () => {
        const  amountMin = (fields.total < MIN_AMOUNT_CARD[props.country]);
        setErrors({ amountMin });
        return !amountMin;        
    }

    const handleChange = (fields) => {
        setFields({
            ...fields,
            total: getTotal(fields.invoices)
        });
    }

    const handleAddInvoice = (fields) => {
        setFields({
            ...fields,
            invoices: [...fields.invoices, {
                id: fields.invoices[fields.invoices.length - 1].id + 1,
                invoice_number: '',
                amount: ''
            }]
        });
    }

    const handleRemoveInvoice = (fields, invoiceDelete) => {
        const invoiceUpdated = fields.invoices.filter(invoice => invoice.id !== invoiceDelete.id)
        setFields({
            ...fields,
            invoices: invoiceUpdated,
            total: getTotal(invoiceUpdated)
        });
    }

    const getTotal = (invoices) => {
        const amount = invoices.reduce(
            (result, current) => Number(result || 0) + Number(current.amount || 0), 0);
        return amount;
    }

    return (
        <CardFormInvoice
            showValidations={true}
            currency="$"
            country={props.country}
            errors={errors}
            fields={fields}
            onChange={fields => handleChange(fields)}
            onSubmit={handleSubmit}
            addInvoice={fields => handleAddInvoice(fields)}
            removeInvoice={(fields, invoice) => handleRemoveInvoice(fields, invoice)}
        />
    );
}

export default CardFormInvoiceContainer;